import { styled, Theme } from '@mui/material';
import Stack from '@mui/material/Stack';

export const StyledEmployerCardWrap = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '296px',
  minHeight: '288px',
  background: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderTop: `5px solid ${theme.palette.primary.main}`,
  borderRadius: '0px 0px 4px 4px',
}));

export const StyledTitlesWrap = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '174px',
  padding: '1rem 1.25rem',
}));

export const StyledEmployerCard = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
  borderTop: `5px solid ${theme.palette.primary.main}`,
  color: theme.palette.common.black,
  marginBottom: theme.spacing(7),
  minHeight: '385px',
  maxWidth: '296px',
  position: 'relative',
  textAlign: 'left',
  width: '100%',
}));

export const StyledEmployerLogo = styled('img')(() => ({
  aspectRatio: '2/1',
  blockSize: 'auto',
  height: '100%',
  maxInlineSize: '100%',
  objectFit: 'contain',
}));

export const StyledEmployerLink = styled('a')(() => ({
  textDecoration: 'none',
}));

export const sxStyles = {
  employerLogoCover: {
    height: '183px',
    width: '100%',
  },
  employerContent: {
    p: 5,
  },
  employerTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
    wordBreak: 'break-word',
    mb: 3,
  }),
  employerDescription: {
    wordBreak: 'break-word',
    overflow: 'hidden',
  },
};
